/**
 * Unified pointer input — mouse on desktop, touch on mobile.
 *
 * Exposes the latest pointer position in *screen* coordinates. The game
 * translates that to a target heading relative to the player's on-screen
 * position (slither.io-style).
 */

export class Input {
  pointerX = 0;
  pointerY = 0;
  pointerActive = false;
  /** Tap-and-hold for the optional boost. Reserved — not wired yet. */
  boostHeld = false;

  private el: HTMLElement;
  private onMove = (e: PointerEvent) => {
    this.pointerX = e.clientX;
    this.pointerY = e.clientY;
    this.pointerActive = true;
  };
  private onDown = (e: PointerEvent) => {
    this.pointerX = e.clientX;
    this.pointerY = e.clientY;
    this.pointerActive = true;
    this.boostHeld = true;
    this.el.setPointerCapture?.(e.pointerId);
  };
  private onUp = () => {
    this.boostHeld = false;
  };

  constructor(el: HTMLElement) {
    this.el = el;
    el.addEventListener("pointermove", this.onMove, { passive: true });
    el.addEventListener("pointerdown", this.onDown, { passive: true });
    el.addEventListener("pointerup", this.onUp, { passive: true });
    el.addEventListener("pointercancel", this.onUp, { passive: true });
  }

  destroy(): void {
    this.el.removeEventListener("pointermove", this.onMove);
    this.el.removeEventListener("pointerdown", this.onDown);
    this.el.removeEventListener("pointerup", this.onUp);
    this.el.removeEventListener("pointercancel", this.onUp);
  }
}
